// src/api/api.js
import axios from "axios";
import Cookies from "js-cookie";
import { clearToken } from "../utils/auth";

// Base URL
const api = axios.create({
  baseURL: "https://apiebooks.azurewebsites.net",
});

// Request interceptor para agregar token desde cookie
api.interceptors.request.use((config) => {
  const token = Cookies.get("icontec_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor para manejar 401
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      // ✅ Limpiar cookie y cualquier sesión
      clearToken();
      // ❌ No usar window.location.href, usar redirect desde la app
      // Puedes lanzar un error específico para que tu componente ProtectedRoute lo capture
      err.isAuthError = true;
    }
    return Promise.reject(err);
  }
);

export default api;
